export default {"src":"/_next/static/media/email.a77485d4.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};